import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useRef } from 'react'
import { useClickAway } from 'react-use'

import QuickActionsMenu from '@/components/layouts/DashboardLayout/components/DashboardSidebar/components/QuickActionsButton/QuickActionsMenu'
import { useQuickActionsMenu } from '@/hooks/useQuickActionsMenu'
import { faPlus, faTimes } from '@/lib/fontAwesomePro/regular'

const QuickActionsButton: React.FC = () => {
  const ref = useRef<HTMLDivElement | null>(null)
  const quickActionsMenu = useQuickActionsMenu()

  // Hide menu on clicking away from it
  useClickAway(ref, quickActionsMenu.hide)

  return (
    <div className="relative mx-auto" ref={ref}>
      <div
        onClick={quickActionsMenu.toggle}
        role="button"
        className="bg-primary flex items-center justify-center rounded-full
          text-white cursor-pointer size-10"
        css={{
          transition: '.3s',
          '&:hover': {
            transform: 'scale(1.1)',
          },
        }}
      >
        <FontAwesomeIcon icon={quickActionsMenu.isShowing ? faTimes : faPlus} />
      </div>

      {quickActionsMenu.isShowing && <QuickActionsMenu />}
    </div>
  )
}

export default QuickActionsButton
